var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.permission)?_c('v-alert',{attrs:{"type":"error"}},[_vm._v("Please turn on location sharing. Share location allow us send you orders quickly.")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }